import React, {
  useState,
  useRef,
  useEffect,
  memo
} from 'react';
import { MTools } from '@/components';
import styles from './index.less';

const step = 0.003;
const stepTime = 0.005;

interface IActivityProps {

}
const Activity: React.FC<IActivityProps> = () => {
  // 当前滑动距离
  const [left, setLeft] = useState(0)
  // timer
  const timerRef = useRef<any>()
  // 图片
  const innerRef = useRef<any>()
  const touch = useRef<any>({})
  useEffect(() => {
    // 开启滑动
    timerRef.current = setTimeout(() => {
      next(left)
    }, 1000);
    return () => {
      clearTimeout(timerRef.current)
    }
  }, [])

  /**
   * 每次滑动
   *
   */
  const next = (current: number) => {
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      const nextCurrent = current + step
      if (current + step > 50) {
        innerRef.current.style.transition = `all 0s`;
        setLeft(0)
        setTimeout(() => {
          innerRef.current.style.transition = `all ${stepTime}s linear`;
          setLeft(step)
          next(step)
        }, 50)
      } else {
        setLeft(nextCurrent)
        next(nextCurrent)
      }
    }, stepTime * 1000)
  }

  const onTouchStart = (e: any) => {
    clearTimeout(timerRef.current)
    const width = window.getComputedStyle(innerRef.current).width
    if (!width) return
    touch.current.initiated = true;
    touch.current.lockTouchEnd = true
    touch.current.startX = e.touches[0].pageX;
    touch.current.width = +width.replace('px', '')
    touch.current.startLeft = left
    innerRef.current.style.transition = `all 0s`;
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', onTouchEnd);
  }
  const onTouchMove = (e: any) => {
    e.preventDefault()
    const deltaX = e.touches[0].pageX - touch.current.startX;
    const width = touch.current.width
    let nextLeft = touch.current.startLeft + (-deltaX / width * 100)
    if (nextLeft > 50) {
      touch.current.startLeft = 0
      touch.current.startX = e.touches[0].pageX
    }
    nextLeft = nextLeft > 50 ? 0 : nextLeft < 0 ? 0 : nextLeft
    touch.current.currentLeft = nextLeft
    setLeft(nextLeft)
  }
  const onTouchEnd = () => {
    document.removeEventListener('touchmove', onTouchMove);
    document.removeEventListener('touchend', onTouchEnd);
    innerRef.current.style.transition = `all ${stepTime}s linear`; touch.current.initiated = false;
    next(touch.current.currentLeft)
  }

  const handleGoToDetail = () => {
    MTools.Url.gotoUrl('/app/activitySchedule');
  }

  return (
    <div className={styles.activity}>
      <div
        className={styles.content}
        onClick={handleGoToDetail}
      >
        <img
          className={styles.image}
          src="https://s.newscdn.cn/file/2022/09/bb90d566-f845-45f0-a0fe-008d97feb999.png"
          alt=""
        />
        <img
          className={styles.image}
          src="https://s.newscdn.cn/file/2022/09/bb90d566-f845-45f0-a0fe-008d97feb999.png"
          alt=""
        />
        <div
          className={styles.inner}
          onTouchStart={onTouchStart}
          ref={innerRef}
          style={{
            transform: `translateX(-${left}%)`
          }}

        >
          <img
            src="https://s.newscdn.cn/file/2022/09/bb90d566-f845-45f0-a0fe-008d97feb999.png"
            alt=""
            draggable="false"
          />
          <img
            src="https://s.newscdn.cn/file/2022/09/bb90d566-f845-45f0-a0fe-008d97feb999.png"
            alt=""
            draggable="false"
          />
        </div>
      </div>
    </div>
  );
};

export default memo(Activity);
